<span
  mat-button
  mat-dialog-close
  class="unlock-close-btn"
  aria-label="Close dialog"
>
  <i id="closeOverlay" class="far fa-times-circle"></i>
</span>

<h1 mat-dialog-title class="unlock-title">OTP VERIFICATION</h1>

<div
  mat-dialog-content
  class="unlock-content"
  role="dialog"
  aria-modal="true"
  aria-labelledby="unlock-title"
>
  <div class="unlock-header">
    <div class="unlock-icon" aria-hidden="true">
      <i class="fas fa-lock"></i>
    </div>
    <p class="unlock-subtitle">Enter the OTP to complete the delivery</p>
  </div>

  <div class="unlock-input-wrap">
    <input
      type="text"
      [(ngModel)]="otp"
      (input)="onInput($event)"
      (keyup.enter)="submitOTP()"
      maxlength="6"
      placeholder="Enter otp code"
      autocomplete="one-time-code"
      class="unlock-input"
    />
  </div>

  <div *ngIf="showError" class="unlock-error">
    Only numbers are allowed.
  </div>
</div>

<div mat-dialog-actions class="unlock-actions">
  <button mat-button mat-dialog-close class="btn-secondary">Close</button>
  
  <button
    mat-button
    class="btn-primary"
    [disabled]="!isValid || loading"
    (click)="submitOTP()"
  >
    <span *ngIf="!loading">Verify</span>
    <span *ngIf="loading" class="unlock-spinner" aria-label="Loading"></span>
  </button>
  
  <button
    mat-button
    class="btn-primary"
    [disabled]="loading"
    (click)="sendOtpToCustomer()"
  >
    <span *ngIf="!loading">Send Otp</span>
    <span *ngIf="loading" class="unlock-spinner" aria-label="Loading"></span>
  </button>
</div>
